jQuery.noConflict();
jQuery(document).ready(function() {
    if( $('.navbanner').length > 0 ) { 
        $(".navbanner_svginfo").click(function () {
            $(".navbanner_subtitle").slideToggle();
            console.log("test")
        });
    }
});